import axios from 'axios';
import { config } from '../config';
import {auth} from "@/firebase.config";

const USER_CACHE_TTL_MS = 30 * 1000;
let cachedUser = null;
let cachedUserUid = null;
let cachedUserAt = 0;
let pendingUserRequest = null;
let cacheGeneration = 0;

export function clearUserCache() {
    cacheGeneration += 1;
    cachedUser = null;
    cachedUserUid = null;
    cachedUserAt = 0;
    pendingUserRequest = null;
}

export async function createUser(data) {
  const host = `${config.service.host}/api`;

  const response = await axios.post(
    `${host}/user`,
    {
      data
    },
    {
      headers: {
        //Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return response.data;
}


// Creates a `users` profile row for an already-authenticated Firebase
// identity (Google Sign-In) — unlike createUser(), this IS authenticated
// (the account already exists client-side; there's no password to prove
// intent with, so the ID token is the proof instead).
export async function createGoogleProfile(data) {
    const host = `${config.service.host}/api`;
    if (!auth.currentUser) {
        throw new Error('Cannot create profile before Google sign-in completes.');
    }
    const accessToken = await auth.currentUser.getIdToken();
    const response = await axios.post(
        `${host}/user/google-profile`,
        { data },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
}

export async function getUser(options = {}) {
    const host = `${config.service.host}/api`;
    const currentUser = auth.currentUser;

    if (!currentUser) {
        clearUserCache();
        throw new Error('Cannot load user before authentication is ready.');
    }

    const uid = currentUser.uid;
    const hasFreshCachedUser = cachedUser
        && cachedUserUid === uid
        && Date.now() - cachedUserAt < USER_CACHE_TTL_MS;

    if (!options.force && hasFreshCachedUser) {
        return cachedUser;
    }

    if (!options.force && pendingUserRequest?.uid === uid) {
        return pendingUserRequest.promise;
    }

    const generation = cacheGeneration;
    const request = { uid, promise: null };
    request.promise = (async () => {
        const accessToken = await currentUser.getIdToken();
        const response = await axios.get(
            `${host}/user/` + uid,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        if (auth.currentUser?.uid !== uid || generation !== cacheGeneration) {
            throw new Error('Authentication or user data changed while loading the profile.');
        }
        if (pendingUserRequest === request) {
            cachedUser = response.data;
            cachedUserUid = uid;
            cachedUserAt = Date.now();
        }
        return response.data;
    })();

    pendingUserRequest = request;
    try {
        return await request.promise;
    } finally {
        if (pendingUserRequest === request) pendingUserRequest = null;
    }
}
async function updateUserCore(data) {
    const host = `${config.service.host}/api`;
    const accessToken = await auth.currentUser.getIdToken(true);

    const response = await axios.put(
        `${host}/user/` + auth.currentUser.uid,
        { data },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );

    clearUserCache();

    return response.data;
}
export async function updateUser(data, dob) {
    if (dob) {
        const year = dob.getUTCFullYear();
        const month = String(dob.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dob.getUTCDate()).padStart(2, '0');
        data.dob = `${year}-${month}-${day}`;
    }

    return updateUserCore(data);
}
export async function updateUserTimezone(timezone) {
    const host = `${config.service.host}/api`;
    const accessToken = await auth.currentUser.getIdToken(true);

    const response = await axios.patch(
        `${host}/user/` + auth.currentUser.uid + `/timezone`,
        { data: { timezone } },   // ✅ 여기서 timezone은 string
        { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    clearUserCache();

    return response.data;
}
